import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import type { Project } from "../data/projects";

export default function ProjectPanel({ project, featured = false }: { project: Project; featured?: boolean }) {
  const actionUrl = project.storeUrl ?? project.trailerUrl;

  return (
    <article className={featured ? "project-panel featured" : "project-panel"} style={{ "--accent": project.accent } as React.CSSProperties}>
      <Link to={`/games/${project.slug}`} className="project-image-link" aria-label={`View ${project.title}`}>
        <img src={project.capsuleImage ?? project.heroImage} alt={`${project.title} artwork`} loading={featured ? "eager" : "lazy"} />
      </Link>
      <div className="project-copy">
        <div className="project-meta">
          {project.status && <span>{project.status}</span>}
          <span>{project.platforms.join(" · ")}</span>
        </div>
        <h3>{project.title}</h3>
        <p>{project.subtitle}</p>
        <div className="badge-row">
          {project.roles.map((role) => <span className="badge" key={role}>{role}</span>)}
        </div>
        <div className="action-row">
          <Link className="text-link" to={`/games/${project.slug}`}>Project details <ArrowUpRight size={16} aria-hidden="true" /></Link>
          {actionUrl && <a className="wishlist" href={actionUrl} target="_blank" rel="noreferrer">{project.ctaLabel}</a>}
        </div>
      </div>
    </article>
  );
}
